import * as api from '../coOpApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  coOpActionCreators,
  CoOpActionKeys,
  ICoOpDealerEstimate,
  UpdateCoOpDealerEstimate
  } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { processMessages } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';

function* updateCoOpDealerEstimateSaga(action: UpdateCoOpDealerEstimate) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IEntityWithMessages<ICoOpDealerEstimate> = yield call(api.updateCoOpDealerEstiamte, action.payload);
  if (response.value) {
    yield put(coOpActionCreators.setDealerEstimates([response.value]));
  }
  yield put(uiActionCreators.hideSpinnerDialog());
  yield processMessages(response, 'There was a problem updating this co-op estime.');
}

export function* watchUpdateCoOpDealerEstimate() {
  yield takeEvery(CoOpActionKeys.UPDATE_COOP_DEALER_ESTIMATE, updateCoOpDealerEstimateSaga);
}
